import { useQuery } from '@tanstack/react-query';

import {
  getClaimReportCardsApi,
  getTicketsReportLastMonthApi,
  postTicketsReportScheduleApi,
} from 'api/reports';
import type {
  GetClaimReportParamsDTO,
  GetClaimReportsResponseDTO,
  GetTicketsReportLastMonthParamsDTO,
  GetTicketsReportLastMonthResponseDTO,
  GetTicketsReportScheduleParamsDTO,
  GetTicketsReportScheduleResponseDTO,
} from 'declarations/dto/reports';
import { RequestQueryKeysE, RequestStaleTimeE } from 'declarations/enums/react-query';
import type { ApiErrorI } from 'declarations/interfaces/errors';

export const useFetchTicketsReportLastMonth = (
  params: GetTicketsReportLastMonthParamsDTO
): ReturnType<typeof useQuery<GetTicketsReportLastMonthResponseDTO, ApiErrorI>> =>
  useQuery<GetTicketsReportLastMonthResponseDTO, ApiErrorI>(
    [RequestQueryKeysE.FetchTicketsReportLastMonth, params],
    async (): Promise<GetTicketsReportLastMonthResponseDTO> => getTicketsReportLastMonthApi(params),
    { staleTime: RequestStaleTimeE.TicketsReportLastMonth }
  );

export const useFetchClaimReports = (
  params: GetClaimReportParamsDTO
): ReturnType<typeof useQuery<GetClaimReportsResponseDTO, ApiErrorI>> =>
  useQuery<GetClaimReportsResponseDTO, ApiErrorI>(
    [RequestQueryKeysE.FetchClaimReportCards, params],
    async (): Promise<GetClaimReportsResponseDTO> => getClaimReportCardsApi(params),
    { staleTime: RequestStaleTimeE.ClaimReportCards }
  );

export const useFetchScheduleReports = (
  params: GetTicketsReportScheduleParamsDTO
): ReturnType<typeof useQuery<GetTicketsReportScheduleResponseDTO, ApiErrorI>> =>
  useQuery<GetTicketsReportScheduleResponseDTO, ApiErrorI>(
    [RequestQueryKeysE.FetchClaimReportCards, params],
    async (): Promise<GetTicketsReportScheduleResponseDTO> => postTicketsReportScheduleApi(params),
    { staleTime: RequestStaleTimeE.ClaimReportCards }
  );
